export default {
  'home.join.title':
    '<h3>協会規範と入会案内</h3>' +
    '<b>多肉男子文化にご関心をお持ちいただき、私たちの一員になりたいと願ってくださりありがとうございます！</b>' +
    '<br />' +
    '協会の運営秩序と会員間の交流の質を維持するため、以下の規範と入会条件をよくお読みいただき、理解し遵守することに同意してください。',
  'home.join.paragraph_1':
    '<h4>📌 入会資格 </h4>' +
    '<ol>' +
    '<li>' +
    '<b>年齢と身分の要件</b>：<br />' +
    '申請者は、法定年齢に達し自主的な法的責任を負う<b>成年男性</b>である必要があります。' +
    '</li>' +
    '<li>' +
    '<b>性別と性的指向の条件</b>：<br />' +
    '本協会の対象は<b>生物学的男性で、かつ性的指向が男性</b>' +
    'の方々です。これは差別によるものではなく、協会の宗旨と文化的立場に基づくものです。ベジタリアンレストランが菜食のみを提供するように、女性専用スペースが異性を制限するのと同じく、特定の身分を対象とすることで安心かつ安全な文化交流の場を提供しています。相互に尊重してください。' +
    '</li>' +
    '<li>' +
    '<b>価値観の同意</b>：<br />' +
    '申請者は<b>協会の宗旨を理解し同意</b>' +
    'し、GMPD文化の普及に参加・支持し、尊重と友好の態度でコミュニティメンバーに接することが必要です。' +
    '</li>' +
    '</ol>',
  'home.join.paragraph_2':
    '<h4>🚫 禁止行為</h4>' +
    '協会のイメージと会員の権益を守るため、以下の行為は<b>一切禁止</b>とし、違反者は状況に応じて警告、利用停止、または会員資格の取り消しを行います：' +
    '<ul>' +
    '<li>' +
    '<b>ゲイ男性への差別または侮辱的な言動</b>' +
    '</li>' +
    '<li>' +
    '<b>体型の多様性（太っている・痩せているを問わず）への差別や侮辱的な言動</b>' +
    '</li>' +
    '<li>' +
    '<b>活動中またはオンライン交流で規範違反や秩序を乱す行為、協会のイメージを損なう行為</b>' +
    '</li>' +
    '<li>' +
    '<b>協会名を用いた嫌がらせ、侵害、詐欺、誤解を招く行為など</b>' +
    '</li>' +
    '</ul>',
  'home.join.paragraph_3':
    '<h4>✍️ 入会手続き</h4>' +
    '<ol>' +
    '<li>' +
    '<b>会員申込書の記入</b>' +
    '<br />' +
    '個人情報と自己紹介を正直に記入してください。内容は審査と内部管理のみに使用され、外部に公開されることはありません。' +
    '</li>' +
    '<li>' +
    '<b>会員規約の確認と同意</b>' +
    '<br />' +
    'このページの規範内容を十分に理解し、すべての規則を遵守することを確認してください。' +
    '</li>' +
    '<li>' +
    '<b>審査と連絡</b>' +
    '<br />' +
    '協会が審査を行い、身分条件と申請動機が宗旨に合致しているかを確認します。結果はメールで通知されます。' +
    '</li>' +
    '</ol>',
  'home.join.paragraph_4':
    '<h4>🤝 共にフレンドリーな空間を築きましょう</h4>' +
    '私たちは多肉男子のための居場所を作りたいと考えています。P、M、G、Dのどの体型であっても、互いに尊重・理解・支援する気持ちがあれば、心から歓迎します。',
  'home.join.paragraph_5':
    'ご不明な点があれば、お問い合わせフォームやSNSを通じてご連絡ください。',
  'home.purpose.title':
    '<h3>協会紹介と宗旨</h3>' +
    '<b>多肉男子文化推進協会</b>' +
    'は、GMPD文化の推進に取り組む民間コミュニティ団体です。私たちは多様な体型を尊重し、ポジティブな価値を築くことを核心に、台湾で大柄な男性を支援・理解・歓迎するコミュニティ空間を作ることを目指しています。',
  'home.purpose.paragraph_1':
    '<h4>協会紹介</h4>' +
    'GMPD文化は日本に由来し、4種類の存在感ある魅力的な体型に注目しています：' +
    '<ul>' +
    '<li>' +
    '<b>G（ガッチリ）</b>：筋肉が発達し、体格がしっかりした体型' +
    '</li>' +
    '<li>' +
    '<b>M（ムッチリ）</b>：脂肪を少し含み、弾力があり豊満な体型' +
    '</li>' +
    '<li>' +
    '<b>P（ぽっちゃり）</b>：丸みがあり可愛らしく、ややふっくらした柔らかい体型' +
    '</li>' +
    '<li>' +
    '<b>D（デブ）</b>：柔らかく豊満で、存在感のある大柄な体型' +
    '</li>' +
    '</ul>',
  'home.purpose.paragraph_2':
    '主流社会では「肥満」はしばしば否定的なラベルとされ、病気と直接結びつけられることがあります。しかし医学研究では、体型と健康の関係は単純ではなく、多くの肥満関連疾患は遺伝、環境、生活習慣など複数の要因が絡み合っています。したがって、すべての非標準体型を病的とみなすのは不正確で無責任な判断です。' +
    '<br />' +
    '私たちは、<b>体型の多様性そのものが文化であり美である</b>と信じています。多肉男子文化推進協会は健康の重要性を否定するものではなく、社会的・心理的な側面から、一人ひとりが安心して自分らしくいられる空間を提供することを目的としています。',
  'home.purpose.paragraph_3':
    '<h4>協会の宗旨</h4>' +
    '<i>世界から体型差別を消し去ることはできないかもしれません。</i>' +
    '<br />' +
    '<i>しかし、少なくとも多肉男子とその体型を好む人々が集い、</i>' +
    '<br />' +
    '<i>互いに理解し、生活を共有し、支え合える場所を作りたいと願っています。</i>',
  'home.purpose.paragraph_4':
    '私たちの主な活動は以下の通りです：' +
    '<ol>' +
    '<li>' +
    '<b>文化交流活動</b>：書展、同人誌即売会、創作交流会などを開催し、芸術や創作を通じて多肉男子文化を広める。' +
    '</li>' +
    '<li>' +
    '<b>健康と体型交流</b>：健康情報、フィットネス知識、体型調整経験を共有し、互いに支援し励ます。' +
    '</li>' +
    '<li>' +
    '<b>知識交流</b>：国内外の関連出版物、研究、文化作品を収集・共有し、文化資産を蓄積する。' +
    '</li>' +
    '</ol>',
};
